import { entityStatusSideMsgValue } from '#/modules/commonComponents/table/entityStatusIconHelpers';
import {
  formatMtrKindLabel,
  formatOriginalSerialList,
} from '#/modules/imsMgmt/settings/mtr/helper/mtrFilterOptions';
import { formatDisplayQty } from '#/utils/formatNumber';

/** Block A：僅狀態 */
export const mtrSideMsgStatusBlock = {
  fields: [
    { label: '狀態', value: entityStatusSideMsgValue },
  ],
};

/** Block C+：其餘欄位 */
export const mtrSideMsgDetailBlock = {
  fields: [
    { label: '料號', value: 'mtrNo' },
    { label: '名稱', value: 'name' },
    {
      label: '物料類型',
      value: (row) => formatMtrKindLabel(row?.mtrKind),
    },
    {
      label: '主分類',
      value: (row) => row?.mtrStructMain?.name ?? '-',
    },
    {
      label: '次分類',
      value: (row) => row?.mtrStructSub?.name ?? '-',
    },
    {
      label: '製造商',
      value: (row) => row?.manufacturer?.name ?? '-',
    },
    {
      label: '基本單位',
      value: (row) => {
        const base = row?.unit?.base ?? row?.baseUnit;
        const label = [base?.code, base?.name].filter(Boolean).join(' · ');
        return label || '-';
      },
    },
    { label: '安全庫存', value: (row) => formatDisplayQty(row?.safetyQty) },
    {
      label: '原廠料號',
      value: (row) => formatOriginalSerialList(row?.originalSerialList),
    },
    { label: '備註', value: 'remark' },
    { label: '模板 ID', value: 'mtrTemplateId' },
  ],
};
